import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { SCREEN_WIDTH } from '../utils/sizes';
import { LOGO_DIMENSIONS } from '../podcast-information/top/podcastInformationTop.style';

export const templates = {
  JumbotronSquare: 'JumbotronSquare',
};

export const VERTICAL_PADDING = {
  [HD]: 56,
  [FULL_HD]: 56,
};

const IMAGE_SIZE = {
  [HD]: 448,
  [FULL_HD]: 448,
};

export const Z_INDEX_NORMAL = 0;

export const Z_INDEX_WITH_PROGRAM_INFO = 1000;

export const sizes = {
  [templates.JumbotronSquare]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        w: SCREEN_WIDTH[HD],
        h: IMAGE_SIZE[HD] + VERTICAL_PADDING[HD],
      },
      [FULL_HD]: {
        w: SCREEN_WIDTH[FULL_HD],
        h: IMAGE_SIZE[FULL_HD] + VERTICAL_PADDING[FULL_HD],
      },
    },
  },
};

export const imageOptions = {
  [templates.JumbotronSquare]: {
    [RENDERING_CONTEXT.GENERAL]: {
      [HD]: {
        PRIMARY: {
          width: IMAGE_SIZE[HD],
          height: IMAGE_SIZE[HD],
        },
        LOGO: {
          ...LOGO_DIMENSIONS[HD],
        },
      },
      [FULL_HD]: {
        PRIMARY: {
          width: IMAGE_SIZE[FULL_HD],
          height: IMAGE_SIZE[FULL_HD],
        },
        LOGO: {
          ...LOGO_DIMENSIONS[FULL_HD],
        },
      },
    },
  },
};
